import { useIntl } from "react-intl";
import { FormInput } from "~components/Form/FormInput";
import { FormSection } from "~components/Form/FormSection";
import parentStyles from "../../AddPersonModal.module.css";
import { addPersonFieldHelpers } from "../../constants/addPersonFieldHelpers";
import type { AddPersonForm } from "../../types/AddPersonForm";

type Props = {
  disabled?: boolean;
};

export const SocialSection = ({ disabled }: Props) => {
  const { formatMessage } = useIntl();
  const { socialFields } = addPersonFieldHelpers;
  return (
    <>
      <FormSection title={formatMessage({ id: "social" })} fields={socialFields} />
      <div className={parentStyles.columnsContainer}>
        <div>
          <FormInput<AddPersonForm>
            name={["social", "website"]}
            label={formatMessage({ id: "website" })}
            disabled={disabled}
          />
          <FormInput<AddPersonForm>
            name={["social", "wikipedia"]}
            label={formatMessage({ id: "wikipedia" })}
            disabled={disabled}
          />
        </div>
        <div>
          <FormInput<AddPersonForm>
            name={["social", "facebook"]}
            label={formatMessage({ id: "facebook" })}
            disabled={disabled}
          />
          <FormInput<AddPersonForm>
            name={["social", "instagram"]}
            label={formatMessage({ id: "instagram" })}
            disabled={disabled}
          />
        </div>
        <div>
          <FormInput<AddPersonForm>
            name={["social", "twitter"]}
            label={formatMessage({ id: "twitter" })}
            disabled={disabled}
          />
        </div>
      </div>
    </>
  );
};
